// Mutation hook - reaktywacja soft-deleted skrzynki mailowej.
// POST /api/ui/sales-crm/mailbox/my-mailbox/reactivate
// Dziala tylko w 30-dniowym grace period (po nim crypto-shredding nieodwracalnie usuwa dane).

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { getMyMailboxQueryKey } from 'api/endpoints/useGetMyMailbox';

interface IReactivateMyMailboxResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

const reactivateMyMailbox = (): Promise<IReactivateMyMailboxResponse> =>
  axios.post('/sales-crm/mailbox/my-mailbox/reactivate');

export const useReactivateMyMailbox = (
  options?: UseMutationOptions<IReactivateMyMailboxResponse, IError, void>
) => {
  const queryClient = useQueryClient();
  return useMutation<IReactivateMyMailboxResponse, IError, void>(reactivateMyMailbox, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(getMyMailboxQueryKey);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
